import { BaseEntityDTO, IBaseEntityDTO } from './';

export interface IRoleDTO extends IBaseEntityDTO {
  role_name: string;
}
export class RoleDTO extends BaseEntityDTO implements IRoleDTO {
  role_name: string;

  constructor(data?: Partial<RoleDTO>) {
    super();
    if (data) {
      Object.assign(this, data);
    }
    this.role_name = data?.role_name ?? '';
  }
}
